import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/storage/storage.service';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';
import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-ai-chat-dialog',
  templateUrl: './ai-chat-dialog.component.html',
  styleUrls: ['./ai-chat-dialog.component.scss']
})
export class AiChatDialogComponent {
  userInput: string = '';
  chatHistory: { question: string | null; answer: string | null; isUser: boolean }[] = [];
  userId: string = '';
  createNewSession: boolean = false;
  userName: string = '';
  userImage!: string;
  orignalChatHistory : any = [];

  @ViewChild('chatBoxInner', { static: false }) chatBoxInner!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<AiChatDialogComponent>,
    private commonService: CommonService,
    private storageService: StorageService,
    private readonly modalService: NgbModal,
    private api: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: { projectDescription: string, projectId: number, projectName: string }
  ) {}

   ngAfterViewChecked() {
    this.scrollToBottom(); // Ensure it scrolls after the view is updated
  }


  scrollToBottom() {
    if (this.chatBoxInner) {
      this.chatBoxInner.nativeElement.scrollTop =
        this.chatBoxInner.nativeElement.scrollHeight;
    }
  }
  ngOnInit(): void {
    let decryptUserId = this.storageService.getValue('userId');
     this.userName = this.storageService.getValue('userName');
    this.userId = this.commonService.Decrypt(decryptUserId);
    this.userImage = this.storageService.getValue('userImage');
    this.commonService.getUserImage().subscribe(image => {
      if (image == '') {
        this.userImage = this.storageService.getValue('userImage') ? this.storageService.getValue('userImage') : '';
      }
      else {
        this.userImage =  image || '';
        localStorage.setItem('userImage', this.userImage);
      }
    });
  }

  sendMessage() {
    if (!this.userInput.trim()) return;

    const currentQuestion = this.userInput;
    this.userInput = '';

    // Show only the user’s question in chat history
    this.chatHistory.push({ question: currentQuestion, answer: 'Processing...', isUser: true });

    const prompt = `Based on the project description, provide in detail answer using only the given details  and for start date and end date of project ignore timing just use date
    \n\nQuestion: ${currentQuestion}
    \n\nProjectDescription : S ${this.data.projectDescription}`;

    this.spinner.show();
    let api = this.api.apiUrl.AI.ChatGPTCreateAPI;
    this.orignalChatHistory.push({ role: 'user', content: prompt, userMessage : currentQuestion })
    let requestedModel = {
      sessionId: (this.userId + this.data.projectId.toString() + this.data.projectName).trim(),
      createNewSession: this.createNewSession,
      messages: this.orignalChatHistory,
    };

    this.commonService.doPost(api, requestedModel).subscribe({
      next: (res) => {
        if (res.success && res.data) {
          this.orignalChatHistory.push(res.data)
          // const lastIndex = this.chatHistory.length - 1;
          // this.chatHistory[lastIndex] = {
          //   question: currentQuestion, // Show only question
          //   answer: res.data.content, // Show only AI response
          //   isUser: false
          // };
          this.chatHistory = this.orignalChatHistory
        .filter((msg: any) => msg.role === 'user' || msg.role === 'assistant') // Keep only user & AI messages
        .map((msg: any) => ({
          question: msg.role === 'user' ? this.cleanText(this.getFormattedResponse(msg.userMessage)) : null, // Clean user question
          answer: msg.role === 'assistant' ? this.cleanText(this.getFormattedResponse(msg.userMessage)) : null, // Clean AI response
          isUser: msg.role === 'user'
        }))
        .filter((msg: { question: null; answer: null }) => msg.question !== null || msg.answer !== null);
          this.createNewSession = false;
        }
        // this.getChatHistory();
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  async getChatHistory() {
  this.spinner.show();
  try {
    const sessionId = (this.userId + this.data.projectId.toString() + this.data.projectName).trim();
    const response = await this.commonService
      .doGet(this.api.apiUrl.AI.GetChatHistory.replace('{sessionId}', sessionId))
      .toPromise();

    if (response?.success) {

      this.chatHistory = response.data
        .filter((msg: any) => msg.role === 'user' || msg.role === 'assistant') // Keep only user & AI messages
        .map((msg: any) => ({
          question: msg.role === 'user' ? this.cleanText(this.getFormattedResponse(msg.userMessage)) : null, // Clean user question
          answer: msg.role === 'assistant' ? this.cleanText(this.getFormattedResponse(msg.userMessage)) : null, // Clean AI response
          isUser: msg.role === 'user'
        }))
        .filter((msg: { question: null; answer: null }) => msg.question !== null || msg.answer !== null); // Remove empty messages
      this.spinner.hide();
    }
  } catch (error) {
    console.error('Error fetching chat history:', error);
    this.spinner.hide();
  }
}

/**
 * Cleans the text by removing unnecessary lines like project descriptions.
 */
cleanText(text: string): string {
  return text
    .replace(/Based on the project description, provide an answer using only the given details/g, '') // Remove intro line
    .replace(/ProjectDescription\s*:.*/g, '') // Remove project description
     .replace(/^\s*Question:\s*/i, '')
    .trim(); // Trim spaces
  }




  newSession() {
    this.spinner.show();
    this.chatHistory = [];
    this.orignalChatHistory = [];
    this.createNewSession = true;
    this.spinner.hide();

  }

  getFormattedResponse(rawResponse: string): string {
    if (!rawResponse) return '';

    // Convert Markdown to HTML
    const html = marked(rawResponse, { async: false });

    // Remove unsafe HTML tags and return as plain string
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText; // Extracts plain text without HTML tags
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
  handleImageError() {
    this.userImage = '../../../assets/img/default-user-profile.svg';
  }

  createNewChat(){
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      {
        backdrop: 'static',
        centered: true,
      }
    );
    modalRef.componentInstance.title = 'Confirm';
    modalRef.componentInstance.message =
      'Are you sure you want create new chat?';
    modalRef.result.then((res: string) => {
      if (res === 'confirm') {
        this.newSession();
      }
    });
  }

}
